import React from "react";
import { Link } from "react-router-dom";
import { FaPlay, FaTrash } from "react-icons/fa";
import { I18n } from "react-redux-i18n";

function getInitials(name) {
  if (!name) return "?";
  return name
    .split(" ")
    .map((part) => part.charAt(0))
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

function getReelPath(item, storeId) {
  const search = storeId ? `?store_id=${encodeURIComponent(storeId)}` : "";
  return `/reels/${item.Id}${search}`;
}

function ReelCard({ item, storeId, canDelete = false, onDelete }) {
  const username = item.User?.Username ? `@${item.User.Username}` : "";
  const reelPath = getReelPath(item, storeId);

  const handleDelete = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (onDelete) onDelete();
  };

  return (
    <article className="reels-card">
      <div className="reels-card__media-wrap">
        {canDelete && (
          <button
            type="button"
            className="reels-card__delete"
            onClick={handleDelete}
            aria-label={I18n.t("store_reels_delete")}
            title={I18n.t("store_reels_delete")}
          >
            <FaTrash />
          </button>
        )}
        <Link to={reelPath} className="reels-card__media">
        {item.Thumbnail ? (
          <img
            src={item.Thumbnail}
            alt={item.Title || "Reel"}
            className="reels-card__thumb"
          />
        ) : (
          <div className="reels-card__thumb reels-card__thumb--placeholder" />
        )}
        <span className="reels-card__play" aria-hidden="true">
          <FaPlay />
        </span>
      </Link>
      </div>

      <div className="reels-card__body">
        <p className="reels-card__title">{item.Title}</p>
        <div className="reels-card__user">
          {item.User?.Avatar ? (
            <img
              src={item.User.Avatar}
              alt={item.User.Name || ""}
              className="reels-card__avatar"
            />
          ) : (
            <div className="reels-card__avatar reels-card__avatar--placeholder">
              {getInitials(item.User?.Name)}
            </div>
          )}
          <div className="reels-card__identity">
            <strong className="reels-card__name">{item.User?.Name}</strong>
            {username && <span className="reels-card__username">{username}</span>}
            {item.CreatedAt && (
              <span className="reels-card__date">{item.CreatedAt}</span>
            )}
          </div>
        </div>
      </div>
    </article>
  );
}

export default ReelCard;
